import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import {
  retrieveWorkspaces,
  cancelAllRequests,
  createWorkspace,
  deleteWorkspace,
  editWorkspace,
  clearPanelTreeList,
} from '../../actions/workspaces';
import { retrieveWorkspace, retrieveBaseSearch, retrieveSortUMOs } from '../../actions/umoGallery';
import { selectWorkspace } from '../../actions/workspacePreview';
import { toggleUMOSortView, toggleWorkspacePreview } from '../../actions/mainUI';
import { addError } from '../../actions/messageDialog';
import WorkspaceDialog from '../WorkspaceDialog';
import PanelTree from '../PanelTree';
import { stringifiedToDraggable } from '../../utils/draggables';
import { validateSessionConnection } from '../../actions/session';
import { moveUmoHandler } from '../../utils/umoUtils';
import appConfig from '../../appConfig';
import WorkspaceSmallIcon from '../Icons/WorkspaceSmallDefault';
import AddIcon from '../Icons/Add';
import PushPinIcon from '../Icons/PushPin';
import AddSubCategoryIcon from '../Icons/AddSubCategoryDefault';
import EditIcon from '../Icons/EditDefaul';
import SortItemsIcon from '../Icons/SortItems';

const mapStateToProps = state => ({
  workspaces: state.workspaces,
  umoGallery: state.umoGallery,
  session: state.session,
});

const mapDispatchToProps = dispatch => ({
  dispatch: actionToDispatch => dispatch(actionToDispatch),
  onWorkspaceClick: (workspaceID, label, description) =>
    dispatch(retrieveWorkspace(workspaceID, label, description)),
  onEditSubmit: (workspaceID, workspaceName, workspaceDescription,
                 workspaceUsers, workspaceRemoveUsers,
                 expiryDate, securityLevel, downloadRule) =>
    dispatch(editWorkspace(workspaceID, workspaceName, workspaceDescription,
      workspaceUsers, workspaceRemoveUsers, expiryDate, securityLevel, downloadRule)),
  onCreateSubmit: (workspaceParentID, workspaceName, workspaceDescription) =>
    dispatch(createWorkspace(workspaceName, workspaceParentID, workspaceDescription)),
  retrieveWorkspaces: workspaceID => dispatch(retrieveWorkspaces(workspaceID)),
  clearPanelTreeList: categoryID => dispatch(clearPanelTreeList(categoryID)),
  onDeleteSubmit: (workspaceID) => {
    dispatch(deleteWorkspace(workspaceID));
    dispatch(selectWorkspace(null, null, null, null));
    dispatch(toggleWorkspacePreview(false));
    dispatch(retrieveBaseSearch());
  },
  cancelAllRequests: () => dispatch(cancelAllRequests()),
  selectWorkspace: ({ workspaceID, workspaceName, workspaceDescription }) => {
    dispatch(toggleWorkspacePreview(true));
    dispatch(
      selectWorkspace(workspaceID, workspaceName, workspaceDescription)
    );
  },
  showErrorMessage: message => dispatch(addError(message)),
  validateSession: surl => dispatch(validateSessionConnection(surl)),
  toggleUMOSort: (workspaceID, workspaceName) => {
    dispatch(retrieveSortUMOs(workspaceID, workspaceName));
    dispatch(toggleUMOSortView(true));
  },
});

class NavWorkspacePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogToShow: null,
    };

    this.customIcons = [
      { icon: <PushPinIcon className='panel-item__pin-icon' />, handler: this.props.selectWorkspace },
    ];

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onWorkspaceCreateClick = this.onWorkspaceCreateClick.bind(this);
    this.onEditSelect = this.onEditSelect.bind(this);
    this.onPanelItemDrop = this.onPanelItemDrop.bind(this);
    this.renderWorkspaceDialog = this.renderWorkspaceDialog.bind(this);
  }

  componentDidMount() {
    // this.props.retrieveWorkspaces();
    if (this.props.workspaces.get('workspaceList').size === 0) this.props.retrieveWorkspaces();
  }

  componentWillUnmount() {
    this.props.cancelAllRequests();
  }

  onDialogClose() {
    this.setState({
      dialogToShow: null,
    });
  }

  onEditSelect(key, workspaceID, workspaceName, workspaceDescription) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        switch (key) {
          case 'edit':
            this.setState({
              dialogToShow: this.renderWorkspaceDialog(true, {
                id: workspaceID,
                name: workspaceName,
                description: workspaceDescription,
              }),
            });
            break;
          case 'subWorkspace':
            this.onWorkspaceCreateClick(null, workspaceID, workspaceName, workspaceDescription);
            break;
          case 'sort':
            this.props.toggleUMOSort(workspaceID, workspaceName);
            break;
          default:
            break;
        }
      }
      return null;
    });
  }

  onWorkspaceCreateClick(e, workspaceParentID, workspaceName, workspaceDescription) {
    this.props.validateSession(this.props.session.get('surl')).then((res) => {
      if (res.isValid) {
        const selectedWorkspaceData = workspaceParentID ? {
          id: workspaceParentID,
          name: workspaceName,
          description: workspaceDescription,
        } : null;

        this.setState({ dialogToShow: this.renderWorkspaceDialog(false, selectedWorkspaceData) });
      }
    });
    return null;
  }

  onPanelItemDrop(e, workspaceID) {
    e.preventDefault();
    $('.main__search-bar').removeAttr('style');
    const draggable = stringifiedToDraggable(e.dataTransfer.getData('text'));
    if (!(draggable instanceof Error) && workspaceID) {
      const origin = {
        id: draggable.originData.workspaceID,
        isWorkspace: draggable.isWorkspaceItem(),
      };
      const target = {
        id: workspaceID,
        isWorkspace: true,
      };
      moveUmoHandler(origin, target, draggable.getSelectionList(), this.props.dispatch,
          draggable.getIsSelectAll() ? draggable.getSearchParams() : null);
    }
  }

  renderWorkspaceDialog(isEdit, selectedWorkspaceData) {
    return (<WorkspaceDialog
      onDialogClose={this.onDialogClose}
      selectedWorkspaceData={selectedWorkspaceData}
      isEditMode={isEdit}
      editRequests={this.props.workspaces.get('editRequests')}
      createRequests={this.props.workspaces.get('createRequests')}
      username={this.props.session.get('username')}
      users={this.props.workspaces.get('users')}
      onEditSubmit={this.props.onEditSubmit}
      onCreateSubmit={this.props.onCreateSubmit}
      onDeleteSubmit={this.props.onDeleteSubmit}
      isHighlight={false}
    />);
  }

  render() {
    const { intl } = this.props;
    const editOptions = [
        { eventKey: 'subWorkspace', icon: <AddSubCategoryIcon />, label: intl.formatMessage({ id: 'navWorkspacePanel.menuAddChild' }) },
        { eventKey: 'edit', icon: <EditIcon />, label: intl.formatMessage({ id: 'navWorkspacePanel.menuEditChild' }) },
    ];
    if (appConfig.enableSortCategory && editOptions) editOptions.push({ eventKey: 'sort', icon: <SortItemsIcon />, label: intl.formatMessage({ id: 'navCategoryPanel.menuSortChild' }) });
    return (
      <div className="nav-content__body nav-workspace">
        <h2 className="nav-content__title nav-content__title--with-sub">
          {intl.formatMessage({ id: 'navWorkspacePanel.workspaceHeader' })}
        </h2>
        <div
          onClick={this.onWorkspaceCreateClick}
          className="nav-content__body__addBtn"
        >
          <AddIcon stroke='#fff'width={20} height={20}/>&nbsp;
          {intl.formatMessage({ id: 'navWorkspacePanel.addWorkspaceButton' })}
        </div>

        <PanelTree
          onPanelItemClick={this.props.onWorkspaceClick}
          onPanelItemDrop={this.onPanelItemDrop}
          retrievePanelTreeList={this.props.retrieveWorkspaces}
          clearPanelTreeList={this.props.clearPanelTreeList}
          panelTreeList={this.props.workspaces.get('workspaceList')}
          retrieveChildrenRequests={this.props.workspaces.get('retrieveChildrenRequests')}
          onEditSelect={this.onEditSelect}
          editOptions={editOptions}
          editRequests={this.props.workspaces.get('editRequests')}
          customIcons={this.customIcons}
          isRoot
          isRetrievingRoot={this.props.workspaces.get('isRetrievingRoot')}
          icon={<WorkspaceSmallIcon style={{margin: '0 6px'}}/>}
        />
        {this.state.dialogToShow}
      </div>
    );
  }
}

NavWorkspacePanel.propTypes = {
  workspaces: PropTypes.instanceOf(Map),
  umoGallery: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  retrieveWorkspaces: PropTypes.func,
  clearPanelTreeList: PropTypes.func,
  cancelAllRequests: PropTypes.func,
  onWorkspaceClick: PropTypes.func,
  onEditSubmit: PropTypes.func,
  onDeleteSubmit: PropTypes.func,
  onCreateSubmit: PropTypes.func,
  selectWorkspace: PropTypes.func,
  validateSession: PropTypes.func,
  dispatch: PropTypes.func,
  toggleUMOSort: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavWorkspacePanel));
